import React, { useEffect, useState } from 'react';
import { Select, Table, Button, Space, Modal, Form, Input, Tag, message, Popconfirm, Card, Switch } from 'antd';
import { fetchPolicies, fetchPolicyIps, addPolicyIp, removePolicyIp } from '../../api';

const reportResult = (res, okMsg) => {
  if (res?.pendingApproval) message.info('Submitted for approval — takes effect once approved.');
  else message.success(okMsg);
};

// IP/CIDR whitelist entries per policy. `kind` OFFICE backs OFFICE_IP_ONLY,
// VPN backs VPN_ONLY (and the composite …_AND_IP / …_AND_VPN types).
const OfficeIpWhitelistTab = () => {
  const [policies, setPolicies] = useState([]);
  const [policyId, setPolicyId] = useState(null);
  const [ips, setIps] = useState([]);
  const [loading, setLoading] = useState(false);
  const [modalOpen, setModalOpen] = useState(false);
  const [form] = Form.useForm();

  useEffect(() => { fetchPolicies().then((r) => setPolicies(r.data || [])).catch(() => {}); }, []);

  const loadIps = async (id) => {
    if (!id) return;
    setLoading(true);
    try { setIps((await fetchPolicyIps(id)).data || []); }
    catch { message.error('Failed to load IPs'); }
    finally { setLoading(false); }
  };
  const onSelectPolicy = (val) => { setPolicyId(val); loadIps(val); };

  const openAdd = () => { form.resetFields(); form.setFieldsValue({ kind: 'OFFICE', enabled: true }); setModalOpen(true); };
  const submit = async () => {
    const values = await form.validateFields();
    try { reportResult(await addPolicyIp(policyId, values), 'IP added'); setModalOpen(false); loadIps(policyId); }
    catch (e) { message.error(e?.response?.data?.message || 'Failed'); }
  };
  const remove = async (ipId) => {
    try { reportResult(await removePolicyIp(policyId, ipId), 'IP removed'); loadIps(policyId); }
    catch (e) { message.error(e?.response?.data?.message || 'Failed'); }
  };

  const columns = [
    { title: 'IP / CIDR', dataIndex: 'ip' },
    { title: 'Kind', dataIndex: 'kind', render: (k) => <Tag color={k === 'VPN' ? 'purple' : 'geekblue'}>{k}</Tag> },
    { title: 'Description', dataIndex: 'description' },
    { title: 'Enabled', dataIndex: 'enabled', render: (v) => (v ? <Tag color="green">Yes</Tag> : <Tag>No</Tag>) },
    {
      title: 'Actions', render: (_, r) => (
        <Popconfirm title="Remove this IP entry?" onConfirm={() => remove(r._id)}><a>Remove</a></Popconfirm>
      ),
    },
  ];

  return (
    <Card size="small">
      <Space direction="vertical" style={{ width: '100%' }} size="middle">
        <Select style={{ width: 360 }} placeholder="Select login policy" value={policyId} onChange={onSelectPolicy}
          options={policies.map((p) => ({ label: `${p.name} (${p.policyType})`, value: p._id }))} />
        {policyId && (
          <>
            <Button type="primary" onClick={openAdd}>Add IP / CIDR</Button>
            <Table rowKey="_id" columns={columns} dataSource={ips} loading={loading} size="small" pagination={false} />
          </>
        )}
      </Space>

      <Modal title="Add IP / CIDR" open={modalOpen} onOk={submit} onCancel={() => setModalOpen(false)} destroyOnClose>
        <Form form={form} layout="vertical">
          <Form.Item name="ip" label="IP or CIDR" rules={[{ required: true }]}>
            <Input placeholder="203.0.113.5 or 203.0.113.0/24" />
          </Form.Item>
          <Form.Item name="kind" label="Kind" rules={[{ required: true }]}>
            <Select options={[{ label: 'OFFICE', value: 'OFFICE' }, { label: 'VPN', value: 'VPN' }]} />
          </Form.Item>
          <Form.Item name="description" label="Description"><Input /></Form.Item>
          <Form.Item name="enabled" label="Enabled" valuePropName="checked"><Switch /></Form.Item>
        </Form>
      </Modal>
    </Card>
  );
};

export default OfficeIpWhitelistTab;
